import { useQuery, useQueryClient } from "@tanstack/react-query";
import API from "@src/API";
import { queryKeys } from "./keys";

async function fetchEmployment() {
  const resp = await API.getAsync("/Person/Employment");
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || resp?.jsonData?.error || "Could not load employment");
  }
  const data = resp.jsonData || {};
  return {
    employmentHistory: Array.isArray(data.employmentHistory) ? data.employmentHistory : [],
    employers: Array.isArray(data.employers) ? data.employers : [],
  };
}

export function useEmploymentQuery(options = {}) {
  return useQuery({
    queryKey: queryKeys.employment(),
    queryFn: fetchEmployment,
    ...options,
  });
}

/** Invalidate employment Query only (no mega Account refresh). */
export async function refreshEmploymentData(queryClient) {
  await queryClient.invalidateQueries({ queryKey: queryKeys.employment() });
  await queryClient.refetchQueries({ queryKey: queryKeys.employment() });
}

export function useRefreshEmployment() {
  const queryClient = useQueryClient();
  return () => refreshEmploymentData(queryClient);
}
